var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helpLink"},[_c('div',{on:{"click":_vm.openTo}},[_c('ig-icon',{staticClass:"icon",attrs:{"name":"bangzhuzhongxin"}}),_c('span',{staticClass:"text"},[_vm._v("  帮助中心")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }